import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    class: "web-mobile-container",
    id: "form-cadastro-container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_FormWizard = _resolveComponent("FormWizard");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_FormWizard, {
            steps: _ctx.formSteps,
            "initial-step-ix": 0,
            store: _ctx.cadastroStore,
            "hide-next-button-on-last-step": false,
            "scroll-to-top-of-form-offset": -250,
            "label-latest-step-button": 'Finalizar cadastro e criar campanha',
            onOnDone: _ctx.onDone,
            onOnStepChange: _cache[0] || (_cache[0] = ($event) => (_ctx.onStepChange()))
        }, null, 8, ["steps", "store", "onOnDone"])
    ]));
}
